<div class="ce-row">
  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <app-analytics-trend-widget
      title="Total payments value"
      metricsKey="total_payments_value"
      formatter="currency"
      [context]="context"
      [analytics]="paymentAnalytics$ | async"
      [errorState]="(totalPaymentError$ | async) || false"></app-analytics-trend-widget>
  </div>

  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <app-analytics-trend-widget
      title="Total payments"
      metricsKey="total_payments"
      [context]="context"
      [analytics]="paymentAnalytics$ | async"
      [errorState]="(paymentError$ | async) || false"></app-analytics-trend-widget>
  </div>
  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <app-analytics-trend-widget
      title="Total refunds"
      metricsKey="total_refunds"
      [context]="context"
      [analytics]="paymentAnalytics$ | async"
      [errorState]="(refundError$ | async) || false"></app-analytics-trend-widget>
  </div>
</div>

<!-- Added Payment Method Distribution Chart -->
<div class="ce-row">
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <div class="grid">
      @if (paymentMethodChartOptions$ | async; as chartOptions) {
        <app-high-chart-container
          class="w-100"
          headingTitle="Payment Methods"
          subtitle="Distribution of successful payments by method"
          [chartOptions]="chartOptions"
          [chartType]="'pie'"
          [emptyStateMessage]="'No payment data available for the selected period'">
        </app-high-chart-container>
      }
    </div>
  </div>
  <!-- Add other charts for payments dashboard here in new columns -->
</div>
